import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { getAppShortlink } from 'marketplace-ui-assets-core/utils/urls';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import getDataFetchingClientStatus from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientErrorStatus';
import ModuleDetailsResponse from 'marketplace-ui-assets-core/details/records/ModuleDetailsResponse';
import { GET_MODULE_DETAILS_PREVIEW } from '../queries/moduleDetailsPreviewQuery';
import NotFoundError from '../../components/error/NotFoundError';
import GenericError from '../../components/error/GenericError';
import ModuleDetailsPage from '../components/ModuleDetailsPage';
import StorefrontUsageTrackerProvider from '../../context/StorefrontUsageTrackerProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ModuleDetailsPreviewContainer() {
  const {
    offeringId
  } = useParams();
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_MODULE_DETAILS_PREVIEW, {
    variables: {
      offeringId: parseInt(offeringId, 10)
    }
  });
  const moduleDetails = useMemo(() => {
    const detailsPreviewData = data || previousData;
    if (!detailsPreviewData) {
      return new ModuleDetailsResponse();
    } else {
      return new ModuleDetailsResponse(detailsPreviewData.detailsPreview);
    }
  }, [data, previousData]);
  const requestState = getDataFetchingClientRequestState(error, loading);
  if (error) {
    switch (getDataFetchingClientStatus(error)) {
      case 403:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "MODULE_DETAILS_FORBIDDEN_ERROR_LOAD",
            children: /*#__PURE__*/_jsx(ErrorMessage, {
              illustration: "keys",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.modules.details.previewForbiddenError.title"
              }),
              children: /*#__PURE__*/_jsx(Button, {
                href: getAppShortlink({
                  pathname: `/modules/_preview/${offeringId}`
                }, false),
                use: "tertiary",
                marginBlockStart: "400",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.modules.details.previewForbiddenError.buttonText"
                })
              })
            })
          });
        }
      case 404:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "MODULE_DETAILS_404_LOAD",
            children: /*#__PURE__*/_jsx(NotFoundError, {})
          });
        }
      default:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "MODULE_DETAILS_ERROR_LOAD",
            children: /*#__PURE__*/_jsx(GenericError, {})
          });
        }
    }
  }
  if (requestState !== RequestState.SUCCEEDED) {
    return null;
  }
  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [/*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.previewAlert.title"
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.previewAlert.message"
      })
    }), /*#__PURE__*/_jsx(ModuleDetailsPage, {
      moduleDetails: moduleDetails,
      use: "preview"
    })]
  });
}